import { GOOGLE } from '@rsos/constants/orgsWithQueueText';
import { isCallerIDFromOrg } from '@rsos/utils/isCallerIDFromOrg';
import { getIsCallerInConnectedSites } from './utils';

const OUTBOUND_SMS = 'outbound_sms';
const defaultQueueItem = {
  data: {},
  mostRecentLocRecord: {},
  isManualSearch: false,
  isCallerIn911informBuilding: false,
  isCallerInConnectedSitesBuilding: false,
  hasGoogleCarCrashData: false,
  hasGoogleCallerInfo: false,
  isTT911: false,
  isAdmin: false,
  source: null,
  hasLocationToRender: false,
  conversation_id: null,
  call_start_time: null,
  isOutboundSMS: false,
};
export const renderLocationHelper = (
  queueItem,
  emergencyCalls,
  hasAgent511Access,
) => {
  let data = defaultQueueItem;
  const isOutboundSMS = queueItem?.textFrom911?.data?.isOutboundSMS;

  // TODO: this file should be broken up into different functions and selectors
  // instead of props drilling
  // spreading `queueItem.textFrom911.data` with the queueItem's data is
  // confusing as the key name is `data`.
  if (isOutboundSMS) {
    data = {
      ...data,
      ...queueItem?.textFrom911?.data,
      souce: OUTBOUND_SMS,
    };
  }

  const mostRecentLocRecord =
    queueItem?.core?.locations[queueItem?.core?.locations?.length - 1] ||
    queueItem?.core?.secondaryLocations[
      queueItem?.core?.secondaryLocations?.length - 1
    ];

  if (!mostRecentLocRecord) {
    return data;
  }

  const hasLocationToRender = Boolean(
    mostRecentLocRecord.latitude && mostRecentLocRecord.longitude,
  );

  const callerID = mostRecentLocRecord.caller_id;

  const isManualSearch = queueItem.isManualSearch;
  const isCallerIn911informBuilding =
    !!queueItem?.additionalData?.['911_inform'];

  const isGoogle = isCallerIDFromOrg(GOOGLE, emergencyCalls, callerID);
  const hasGoogleCarCrashData = !!(
    isGoogle &&
    queueItem.additionalData.google &&
    queueItem.additionalData.google.data &&
    queueItem.additionalData.google.data.crash_detection
  );
  const hasGoogleCallerInfo = !!(
    isGoogle &&
    queueItem.additionalData.google &&
    queueItem.additionalData.google.data &&
    queueItem.additionalData.google.data.caller_info
  );
  const isCallerInConnectedSitesBuilding =
    getIsCallerInConnectedSites(queueItem);

  const isTT911 = hasAgent511Access && queueItem?.isTT911;
  const isAdmin = queueItem?.isAdmin;
  const source = mostRecentLocRecord.source;
  return {
    ...data,
    mostRecentLocRecord,
    isManualSearch,
    isCallerIn911informBuilding,
    isCallerInConnectedSitesBuilding,
    hasGoogleCarCrashData,
    hasGoogleCallerInfo,
    isAdmin,
    isTT911,
    source,
    hasLocationToRender,
  };
};
